/**
 * KAN-862: вкладка "Доска" приложения менеджера (/m/board): канбан CRM в
 * мобильном виде (колонка на экран, вкладки колонок, "Сменить этап"),
 * панель группировки, исхода и активности (настройки в адресе).
 * Карточка ведёт в карточку клиента приложения.
 * KAN-865: клик по карточке открывает панель карточки клиента снизу
 * (?card=<id>), "Карточка клиента" ведёт в карточку приложения; фильтр
 * "Требуют внимания". MobileLayout не рисует модалку переписки, поэтому
 * TranscriptDialogHost здесь: иконка "Переписка" в панели открывает её.
 * KAN-874: рядом с заголовком ссылка "Полная CRM" в CRM кабинета
 * (?desktop=1 оставляет в кабинете).
 * KAN-881: ссылка открывается в новой вкладке браузера (target=_blank):
 * scope приложения /m/, кабинет не должен открываться внутри приложения.
 */
import { CrmBoardSection } from '@/components/crm/board/CrmBoardSection';
import { TranscriptDialogHost } from '@/components/dashboard/TranscriptDialogHost';
import { CABINET_CRM_PATH, mobileClientPath, mobileCompanyPath } from '@/lib/mobileApp';
import type { CrmPipelineCard } from '@/types/crmPipeline';

const clientHref = (card: CrmPipelineCard) => mobileClientPath(card.id);

export function MobileBoardPage(): JSX.Element {
  return (
    <section className="overflow-x-hidden px-4 py-4" data-testid="mobile-board-page">
      <header className="mb-3 flex items-center justify-between gap-3">
        <h1 className="text-xl font-semibold text-gray-900">Доска</h1>
        <a
          href={CABINET_CRM_PATH}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="mobile-board-full-crm"
          className="inline-flex min-h-[36px] shrink-0 items-center rounded-md px-2 text-sm font-medium text-blue-600 active:bg-blue-50"
        >
          Полная CRM
        </a>
      </header>
      <div className="space-y-3">
        <CrmBoardSection
          variant="mobile"
          clientHref={clientHref}
          panelClientHref={mobileClientPath}
          companyHref={mobileCompanyPath}
          surface="app"
        />
      </div>
      <TranscriptDialogHost />
    </section>
  );
}
